import React, { useState } from 'react';
import { Row, Col, Form, Input, Button, message, Result, Select } from 'antd';
import { TopSection } from './About'; // Assuming TopSection is a common header component
import axios from 'axios';
import { SmileOutlined } from '@ant-design/icons';

const { Option } = Select;

const MembershipForm = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // You'll need to create a new API endpoint for membership applications
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/membership-applications`, values);
            form.resetFields();
            setSubmitted(true);
            setLoading(false);
        } catch (error) {
            console.error('Error submitting membership application:', error);
            message.error('Failed to submit your membership application. Please try again later.');
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <>
                <TopSection heading={'Membership Application'} />
                <div
                    style={{
                        padding: '60px 20px',
                        minHeight: '60vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Result
                        icon={<SmileOutlined style={{ color: '#ff4d4f' }} />}
                        title={<h2 style={{ color: '#ff4d4f', fontSize: '32px' }}>Thank You for Your Application!</h2>}
                        subTitle={
                            <p style={{ fontSize: '18px', fontFamily: 'Outfit, sans-serif' }}>
                                We've received your membership application and will review it shortly. You'll hear from us soon!
                            </p>
                        }
                        extra={
                            <Button
                                type="primary"
                                onClick={() => setSubmitted(false)}
                                style={{
                                    backgroundColor: '#ff814a',
                                    borderColor: '#ff814a',
                                    fontWeight: 'bold',
                                    borderRadius: 20,
                                    fontSize: '16px',
                                    fontFamily: 'Outfit, sans-serif',
                                }}
                            >
                                Apply for Another Membership
                            </Button>
                        }
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <TopSection heading={'Become a Member'} />

            <div style={{ padding: '60px 20px' }}>
                <Row justify="center" gutter={[32, 32]} style={{ maxWidth: 1100, margin: 'auto' }}>
                    {/* Left Info Block - You might want to update this with membership benefits or general info */}


                    {/* Right Form Block */}
                    <Col xs={24} md={12}>
                        <div
                            style={{
                                border: '2px dashed red',
                                borderRadius: 50,
                                padding: 30,
                                background: '#fff',
                            }}
                        >
                            <h2 style={{ textAlign: 'center', marginBottom: 20, fontSize: '26px' }}>Membership Application</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                style={{ fontSize: '16px' }}
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    name="fullName"
                                    label="Full Name"
                                    rules={[{ required: true, message: 'Please enter your full name' }]}
                                >
                                    <Input
                                        className="newsletter-input"
                                        placeholder="Enter Full name"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="mobile"
                                    label="Mobile Number"
                                    rules={[{ required: true, message: 'Please enter your mobile number' }]}
                                >
                                    <Input
                                        placeholder="Enter Mobile No."
                                        className="newsletter-input"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="email"
                                    label="Email"
                                    rules={[
                                        { required: true, message: 'Please enter your email' },
                                        { type: 'email', message: 'Please enter a valid email' },
                                    ]}
                                >
                                    <Input
                                        className="newsletter-input"
                                        placeholder="Email"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="plan"
                                    label="Choose Your Plan"
                                    rules={[{ required: true, message: 'Please select a membership plan' }]}
                                >
                                    <Select
                                        placeholder="Select a plan"
                                        className="newsletter-input"

                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    >
                                        <Option value="3-months">3 Months</Option>
                                        <Option value="6-months">6 Months</Option>
                                        <Option value="1-year">1 Year</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="message"
                                    label="Additional Message (Optional)"
                                >
                                    <Input.TextArea
                                        placeholder="Any additional information or questions?"
                                        className="newsletter-input"
                                        rows={3}
                                        style={{
                                            fontFamily: 'Outfit, sans-serif',
                                            fontSize: '16px',
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        loading={loading}
                                        style={{
                                            backgroundColor: '#ff814a',
                                            borderColor: '#ff814a',
                                            fontWeight: 'bold',
                                            width: 150,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            margin: 'auto',
                                            borderRadius: 20,
                                            fontSize: '16px',
                                            fontFamily: 'Outfit, sans-serif',
                                        }}
                                    >
                                        Apply Now
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default MembershipForm;